export enum URLS {
  // HOST URLs
  STORES = '/overview/stores/',
  REQUESTS = '/overview/requests/',
  ACCOUNT = '/overview/account/:tab',
  ORDERS = '/overview/orders/',
  PRODUCTS = '/overview/services-calendar/',
  INTEGRATION = '/overview/integrations/:company/',
  OWNER_MANAGE_ORDER = '/owner/:ownerOrderUuid/?showPrices=True', // The owner always sees the prices
  STORE_DETAILS = '/dashboard/store/:storeId/',
  STORE_SALES_LIST = '/dashboard/store/:storeId/sales/',
  STORE_SALE_DETAILS = '/dashboard/store/:storeId/sales/:purchaseId/',
  STORE_SIGNAGE = '/dashboard/store/:storeId/signage/',
  STORE_PRODUCTS_BY_CATEGORY = '/dashboard/store/:storeId/products/:category/',

  // GUEST URLs
  GUEST_STORE = '/store/:storeId/',
  CHECKOUT_DETAILS = '/store/:storeId/:orderId/checkout-details/',
  CHECKOUT = '/store/:storeId/checkout/:orderId/:customerId/',
  CART_DETAILS = '/store/:storeId/cart/',
  ONBOARDING_VIDEO = '/onboarding/onboarding-video/',

  // PUBLIC URLs
  VENDORS = '/vendors/',
}
